import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';

class CenterSwitcher extends Component {
  async handleSwitch (e) {
    this.props.onSwitch(e.target.value);
  }

  render () {
    return (
      <FormControl
        componentClass='select' value={this.props.centerId} onChange={(e) => this.handleSwitch(e)}>
        { this.props.centers.map((center) =>
          <option key={center.id} value={center.id}>{center.name}</option>
        )}
      </FormControl>
    );
  }
}
export default CenterSwitcher;
